import { simpleBindingSelector } from '@common/redux/selectors/page';
import { IOnPressProps } from '@common/types/action';
import { getValueBindingComponent } from '@common/utils/component';
import { get, pick } from 'lodash';
import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';

type Props = {
  ObjectClass: FC;
  obj: any;
  dependencies: any;
  onPress: (actionId: string, options: IOnPressProps) => any;
};

const SimpleObjectWrap = ({
  ObjectClass,
  obj,
  dependencies,
  onPress,
}: Props) => {
  const data = useSelector(simpleBindingSelector(obj.id));
  const visibility =
    typeof get(data, 'visibility') === 'boolean'
      ? get(data, 'visibility')
      : getValueBindingComponent(obj, 'visibility');

  //visibility
  if (JSON.stringify(visibility) === 'false')
    return (
      <View
        style={{
          ...pick(obj, ['width', 'height', 'marginTop', 'marginLeft']),
          zIndex: -1,
        }}
      />
    );

  return (
    <ObjectClass
      {...obj}
      data={data}
      dependencies={dependencies}
      onPress={onPress}
    />
  );
};

export default SimpleObjectWrap;
